import { AppleIcon, AndroidIcon, ArrowIcon } from '../icons';
import { APP_STORE_URL, PLAY_STORE_URL, SUPPORT_EMAIL } from '../content';

export function CTA() {
  return (
    <section
      className="section grain"
      style={{
        position: 'relative',
        overflow: 'hidden',
        borderTop: '0.5px solid var(--line-1)',
        background: 'radial-gradient(120% 120% at 50% 0%, #16161d, var(--bg-0) 60%)',
      }}
    >
      <div
        className="container"
        style={{ position: 'relative', zIndex: 2, textAlign: 'center' }}
      >
        <h2 className="h-display" style={{ fontSize: 'clamp(34px,5vw,68px)' }}>
          Bring the studio
          <br />
          with you.
        </h2>
        <p className="h-sub" style={{ margin: '22px auto 0' }}>
          Free to start. Pro when you&apos;re ready.
        </p>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexWrap: 'wrap',
            gap: 12,
            marginTop: 36,
          }}
        >
          <a
            className="btn btn-solid"
            href={APP_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            <AppleIcon /> App Store
          </a>
          <a
            className="btn btn-ghost"
            href={PLAY_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            <AndroidIcon /> Google Play
          </a>
          <a className="btn btn-ghost" href={`mailto:${SUPPORT_EMAIL}`}>
            Talk to us <ArrowIcon />
          </a>
        </div>
      </div>
    </section>
  );
}
